<template>
  <div class="general-data">
    <nav class="general-data__menu">
      <div class="general-data__account">
        <svg-loader src="/static/images/dados-gerais/logo-lab.svg" />
        <span>{{ profile.laboratoryName }}</span>
      </div>
      <ul class="general-data__list">
        <template
          v-for="{ name, description, feature, validFeature } in tabSelections"
        >
          <li
            v-if="shouldShowMenuItem(validFeature, feature)"
            :key="name"
            :class="{ active: selected === name }"
            @click="selected = name"
          >
            {{ description }}
            <svg-loader src="/static/images/dados-gerais/arrow-right.svg" />
          </li>
        </template>
      </ul>
    </nav>
    <div class="general-data__content">
      <div
        v-if="selectedTab"
        class="card"
      >
        <div
          v-if="!selectedTab.withoutHeader"
          class="general-data__header"
        >
          <h2>{{ selectedTab.description }}</h2>
        </div>
        <component
          :is="selectedTab.component"
          :class="{
            component: !selectedTab.withoutHeader
          }"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AlvaroContactsTab from './components/AlvaroContactsTab.vue'
import GeneralDataTab from './components/GeneralDataTab.vue'
import LabContacts from './components/LabContactsTab.vue'
import TeamTab from './components/TeamTab.vue'
import AccountTab from './components/AccountTab.vue'

export default {
  components: {
    AlvaroContactsTab,
    GeneralDataTab,
    LabContacts,
    TeamTab,
    AccountTab
  },
  data() {
    return {
      selected: 'generalData',
      tabSelections: [{
        name: 'generalData',
        description: 'Dados Gerais',
        validFeature: false,
        withoutHeader: false,
        component: GeneralDataTab
      },
      {
        name: 'contacts',
        description: 'Contatos',
        validFeature: false,
        withoutHeader: true,
        component: LabContacts
      },
      {
        name: 'apoio',
        description: 'Alvaro Apoio',
        validFeature: false,
        withoutHeader: false,
        component: AlvaroContactsTab
      },
      {
        name: 'team',
        description: 'Minha Equipe',
        feature: 'crudUser',
        validFeature: true,
        withoutHeader: true,
        component: TeamTab
      },
      {
        name: 'account',
        description: 'Informações da conta',
        validFeature: false,
        withoutHeader: false,
        component: AccountTab
      },
      ],
    }
  },
  computed: {
    ...mapGetters(['profile', 'toggle']),
    selectedTab() {
      return this.tabSelections.find(tab => tab.name === this.selected);
    }
  },
  mounted() {
    this.getOperatorInfo(this.profile.id_operator);
  },
  methods: {
    ...mapActions(['getOperatorInfo']),
    shouldShowMenuItem(validFeature, feature) {
      const isAdminOrManager = this.profile.idRole === 1 || this.profile.idRole === 4;
      return isAdminOrManager || (validFeature ? this.toggle[feature] : true);
    }
  },
}
</script>

<style lang="scss">
@import '../../../static/stylesheets/variables';

.general-data {
  padding-top: $mainHeaderHeight;
  margin-top: 3em;
  display: flex;
  justify-content: center;
  font-family: 'Exo 2' !important;

  &__menu {
    width: 230px;
  }

  &__account {
    display: flex;
    align-items: center;
    margin-bottom: 24px;

    span {
      margin-left: 8px;
      flex-shrink: 1;
      font-size: 14px;
      color: #363636;
      font-weight: 600;
    }

    svg,
    i {
      width: 40px;
      height: 40px;
      min-width: 40px;
      min-height: 40px;
    }
  }

  &__content {
    flex: 1 1 auto;
    max-width: 700px;
    margin-left: 64px;

    .empty-list {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-top: 110px;
      color: #818181;
      font-size: 23px;

      img {
        margin-bottom: 24px;
      }
    }
  }

  &__list {
    li {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 16px;
      border-radius: 6px;
      height: 41px;
      font-weight: 600;
      color: #595959;
      cursor: pointer;

      &.active {
        background: #fcf2f8;
        color: #7f1a54;

        i path {
          fill: #7f1a54;
        }
      }

      i {
        width: 16px;
        height: 16px;
        min-width: 16px;
        min-height: 16px;
        margin: 0;
      }
    }
  }

  &__box-wrapper {
    display: flex;
    gap: 12px;
    justify-content: center;
    align-items: center;
  }

  &__content-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    min-height: 44px;
    flex: 1;
    border: 2px #fff solid;
    background-color: #fff;
    border-radius: 6px;
    margin-bottom: 6px;
    padding: 4px;

    p {
      flex: 1;
      display: flex;
      justify-content: space-between;
      gap: 8px;
      align-items: center;

      span {
        flex: 1;
        display: flex;
        align-items: center;
      }
    }

    span {
      font-size: 14px;
      color: #363636;
      width: 100px;
      font-weight: bold;

      &.error {
        color: #b10000;
        font-size: 12px;
        display: block;
        width: 100%;
        margin-top: -6px;
        margin-bottom: 4px;
      }
    }

    input {
      font-size: 14px;
      border: none;
      border-bottom: 1px solid #dcdcdc;
      padding: 8px;
      border-radius: 0;
      flex: 1;
      outline: none;
      height: 30px;
      font-family: 'Exo 2' !important;
    }

    input:disabled {
      background-color: #f5f5f5;
    }

    select {
      flex: 1;
      border: none;
      border-bottom: 1px solid #dcdcdc;
      padding-bottom: 4px;
      font-family: 'Exo 2' !important;
      outline: none;
      font-size: 14px;
    }

    button.invisible {
      background-color: transparent;
    }

    .md-icon {
      margin: 0;
      cursor: pointer;

      path {
        stroke: #818181;
      }

      &.edit {
        width: 20px;
        min-width: 20px;

        >svg {
          fill: transparent;
        }

        &:hover {
          path {
            stroke: #7f1a54;
          }
        }
      }

      &.check {
        width: 22px;
        min-width: 22px;

        &:hover {
          path {
            fill: #7f1a54;
          }
        }

        path {
          fill: #818181;
        }
      }
    }

    >div {
      flex: 1;
    }
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #6d6d6d;

    h2 {
      font-size: 18px;
      letter-spacing: 0.1px;
      text-align: left;
      color: #7f1a54;
      font-weight: 600;
      text-transform: uppercase;
    }

    .btn {
      display: flex;
      align-items: center;
      padding: 11px 20px;
      font-size: 13.33px;
      font-family: 'Exo 2';
      font-weight: 600;
      text-transform: uppercase;
      color: #ffffff;

      img {
        margin-right: 8px;
      }
    }
  }

  .component {
    margin-top: 30px;
  }

  .card {
    padding: 20px 27px;
    border-radius: 6px;
    margin-bottom: 24px;
  }

  .contact-section {
    margin-bottom: 16px;
    background-color: #fff;
    padding: 12px;
    border: 4px #fff solid;
    border-radius: 6px;

    h3 {
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 8px;
    }

    p {
      font-size: 14px;
      color: #818181;
      margin-bottom: 8px;
    }

    .general-data__content-wrapper {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
      min-height: inherit;
      margin-bottom: 16px;

      input {
        flex: 1;
      }
    }

    .add-button {
      background-color: transparent;
      color: #7f1a54;
      border: none;
      font-weight: 600;
      height: inherit;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }

      &.not-gap {
        margin-top: 14px;
      }

      &.delete-button {
        margin-top: -16px;
      }
    }

    input {
      width: 100%;
      padding: 8px;
      border: 1px solid #ddd;
    }

    &__box-inputs {
      display: flex;
      width: 100%;
      gap: 14px;
    }
  }

  .save-button {
    background-color: #741946;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 10px 20px;
    font-family: 'Exo 2' !important;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: 1px;
    cursor: pointer;

    &:hover {
      background-color: #5d1538;
    }

    &-container {
      display: flex;
      justify-content: flex-end;
      margin-top: 20px;
    }
  }
}
</style>
